module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('popup', {
    model: {
      value: (_vm.isActive),
      callback: function($$v) {
        _vm.isActive = $$v
      },
      expression: "isActive"
    }
  }, [_c('div', {
    staticClass: "messageMode"
  }, [_c('div', {
    staticClass: "saveMessage"
  }, [_c('div', {
    staticClass: "icon-x",
    on: {
      "click": function($event) {
        return _vm.determine('on-close')
      }
    }
  }), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), _c('ul', {
    staticClass: "btn-group"
  }, [_c('li', {
    staticClass: "cancel",
    on: {
      "click": function($event) {
        return _vm.determine('on-cancel')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.cancelText) + "\n        ")]), _vm._v(" "), _c('li', {
    staticClass: "sure",
    attrs: {
      "id": "confirm-sure"
    },
    on: {
      "click": function($event) {
        return _vm.determine('on-sure')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.sureText) + "\n        ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-188f8935","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Confirm.vue
// module id = 793
// module chunks = 0